import { Theme } from '@material-ui/core';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function componentWithStyles({ palette, spacing, typography }: Theme) {
    return {
        root: {},
        typingNotification: {
            '& span': {
                animationName: `$ellipsis`,
                animationDuration: '1.4s',
                animationIterationCount: 'infinite',
                animationFillMode: 'both',
            },
            '& span:nth-child(2)': {
                animationDelay: '.2s',
            },
            '& span:nth-child(3)': {
                animationDelay: '.4s',
            },
        },
        '@keyframes ellipsis': {
            /**
             * At the start of the animation the dot
             * has an opacity of .2
             */
            '0%': {
                opacity: .2,
            },
            /**
             * At 20% the dot is fully visible and
             * then fades out slowly
             */
            '20%': {
                opacity: 1,
            },
            /**
             * Until it reaches an opacity of .2 and
             * the animation can start again
             */
            '100%': {
                opacity: .2,
            },
        },
    };
}